/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const emailTemplateDataSchema = z.object({
	id: z.string(),
	organisationId: z.string(),
	name: z.string(),
	subject: z.string().nullable(),
	body: z.string(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
})

export type EmailTemplateDataSchema = z.infer<typeof emailTemplateDataSchema>
